import './AboutUs.css';
import {Component} from "react";
import Top from "./Top";
import Footer from "./Footer";
import arrow from '../image/arrow.png'

class aboutUs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            websiteTermOfUse: false,
            tradingTerms: false,
            prePayment: false,
            depositsPaid: false,
            membershipReward: false
        }
    }

    websiteTermOfUse() {
        if (this.state.websiteTermOfUse) {
            this.setState({
                websiteTermOfUse: false
            })
        } else {
            this.setState({
                websiteTermOfUse: true,
                tradingTerms: false,
                prePayment: false,
                depositsPaid: false,
                membershipReward: false
            })
        }
    }

    tradingTerms() {
        if (this.state.tradingTerms) {
            this.setState({
                tradingTerms: false
            })
        } else {
            this.setState({
                websiteTermOfUse: false,
                tradingTerms: true,
                prePayment: false,
                depositsPaid: false,
                membershipReward: false
            })
        }
    }

    prePayment() {
        if (this.state.prePayment) {
            this.setState({
                prePayment: false
            })
        } else {
            this.setState({
                websiteTermOfUse: false,
                tradingTerms: false,
                prePayment: true,
                depositsPaid: false,
                membershipReward: false
            })
        }
    }

    depositsPaid() {
        if (this.state.depositsPaid) {
            this.setState({
                depositsPaid: false
            })
        } else {
            this.setState({
                websiteTermOfUse: false,
                tradingTerms: false,
                prePayment: false,
                depositsPaid: true,
                membershipReward: false
            })
        }
    }

    membershipReward() {
        if (this.state.membershipReward) {
            this.setState({
                membershipReward: false
            })
        } else {
            this.setState({
                websiteTermOfUse: false,
                tradingTerms: false,
                prePayment: false,
                depositsPaid: false,
                membershipReward: true
            })
        }
    }

    render() {
        return (<div className="about-us">
            <Top/>
            <div className="about-us-model-box section-background-gray">
                <div className="about-us-big-word">About Us</div>
            </div>
            <div className="about-us-model-box">
                <div className="about-us-model-box-title">Our Company</div>
                <div className="about-us-model-box-paragraph">Nebula Binary Software Technology Inc., trading as
                    https://www.nebulabinary.com/ (“GAME”,
                    “Us”, “We” or “Our”), a company registered in British Columbia (Business Number
                    #746630144BC0001) whose registered
                    address is at: 1771 Robson Street, Vancouver, BC, Canada, V6G 3B7.
                </div>
            </div>
            <div className='about-us-model-box section-background-gray'>
                <div className="about-us-model-box-title">Terms & Conditions</div>
                <div className="about-us-model-box-paragraph">
                    <div>The products and services offered by Us through this https://www.nebulabinary.com/ website
                        (the “Site”) are subject to the Website Terms of Use and Trading Terms set out below which
                        together form
                        the terms and conditions (“Terms and Conditions”). By using the Site, you accept, without
                        limitation or qualification, these Terms and Conditions. If you do not agree to these Terms
                        and Conditions, please do not use this Site.
                    </div>
                    <br/>
                    <div>We reserve the right to update the Terms and Conditions at any time. When We do so, We will
                        provide access to the new Terms and Conditions on the Site home page. The new Terms and
                        Conditions will take effect immediately and will govern all transactions with Us through the
                        Site. If you do not agree with the new version of the Terms and Conditions, you must cease
                        to use the Site.
                    </div>
                    <br/>
                    <div>Privacy and Data Protection We are committed to protecting your privacy. Please also see
                        our privacy policy for further information on how we handle your personal information and
                        who we share it with.
                    </div>
                </div>
            </div>
            <div className='about-us-model-box'>
                <div className="about-us-model-box-title">Privacy Policy</div>
                <div className="about-us-model-box-paragraph">
                    <div className="about-us-paragraph-div">Nebula Binary Software Technology Inc.
                        (Business Number #746630144BC0001) is the controller responsible for your personal
                        data (collectively referred to as the “Company”, “we”, “us” or “our” in this privacy
                        policy).
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div">If you have any questions relating to our
                        use of your data or this privacy policy,
                        including any requests to exercise your legal rights, please contact our data protection
                        team using the details set out below:
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div">Email: dataprotect@nebulabinary.com
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div">
                        Postal address: 1771 Robson Street, Vancouver, BC, Canada, V6G 3B7
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div">
                        You have the right to make a complaint at any time to the relevant supervisory authority. We
                        would, however, appreciate the chance to deal with your concerns before you approach the ICO
                        so please contact us in the first instance.
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div-bold">
                        CHANGES TO THE PRIVACY POLICY AND YOUR DUTY TO INFORM US OF CHANGES
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div">
                        This policy was last updated on the date shown at the top of the document. We reserve the
                        right to make further changes to this policy from time to time. We will always notify you in
                        advance of any changes that involve a new use of your data that may not be compatible with
                        the purpose for which we originally collected them.
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div">
                        It is important that the personal data we hold about you is accurate and current so please
                        keep us informed if your personal data changes during your relationship with us.
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div-bold">
                        THIRD-PARTY LINKS
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div">
                        Our websites, https://www.nebulabinary.com/ and others we may operate from time to time may
                        include links
                        to third-party websites, plug-ins and applications.
                    </div>
                    <br/>
                    <div className="about-us-paragraph-div">
                        Clicking on those links or enabling those connections may allow third parties to collect or
                        share data about you. We do not control these third-party websites and are not responsible
                        for their privacy statements. When you leave our website, we encourage you to read the
                        privacy policy of every website you visit.
                    </div>
                </div>
            </div>
            <div className='about-us-model-box section-background-gray'>
                <div className='about-us-tab-container'>
                    <div className='about-us-tab' onClick={this.websiteTermOfUse.bind(this)}>
                        <div className='about-us-tab-child'>
                            {
                                this.state.websiteTermOfUse ?
                                    <img className='arrow-rotate' alt='error-img' src={arrow}/> :
                                    <img className='arrow' alt='error-img' src={arrow}/>
                            }
                            Website Terms of Use
                        </div>
                    </div>
                    {this.state.websiteTermOfUse ? <div className='about-us-tab-content'>
                        <div className='about-us-tab-div section-content-highlight'>
                            Accessing the Site
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We reserve the right, at our discretion, to withdraw, suspend or modify the Site
                            or certain features or parts of the Site with or without notice to you, where We
                            have reason to do so. There may also be times when the Site or certain features
                            or parts of the Site become unavailable, whether on a scheduled or unscheduled
                            basis. You agree that We will not be liable to you or to any third party for any
                            withdrawal, modification, unavailability, suspension or discontinuance of the
                            Site or any service available on or through the Site.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We do not accept liability for any losses or claims arising from any inability
                            to access the Site or any failure to complete a transaction.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Using the Site
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            This Site is for personal and non-commercial use. You must not use any materials
                            contained in the Site except to the extent necessary for your own personal use.
                            In using the Site and information available from the Site, you agree that you
                            will not:
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (a) post, disseminate or transmit unauthorised advertisements or promotional
                            materials, chain letters, junk mail or any other type of unsolicited mass email
                            to people or entities who have not agreed to be part of such mailings;
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (b) omit, delete, forge or misrepresent transmission information, including
                            headers, return mailing and Internet protocol addresses or otherwise manipulate
                            identifiers to disguise the origin of any content;
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (c) impersonate any person or entity, or fail to state or otherwise misrepresent
                            an affiliation with any person or entity;
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (d) engage in any activities in order to withhold or cloak identity or contact
                            information;
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (e) send harassing and/or threatening messages to others;
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (f) engage in “flooding” – i.e. ICMP flooding and mail bombing (sending large
                            amounts of email repeatedly to the same email address);
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (g) use the information available on the Site for any illegal, immoral or
                            anti-social purpose, in violation of any applicable laws or regulations or in a
                            manner which is or may be damaging to Our name or reputation;
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (h) electronically stalk or otherwise electronically harass another;
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (i) engage in any Internet activities that would violate the personal privacy
                            rights of others, including but not limited to, collecting and distributing
                            information about Internet users without their permission.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            You agree that you are responsible for your own communications and that you will
                            not post, disseminate or transmit any content that:
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (1) contains personally identifiable information belonging to minors;
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (2) is for commercial purposes or contains advertising or is intended to solicit
                            a person to buy or sell services or to make donations.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Accuracy of information
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We will use reasonable endeavours to ensure that information on the Site is
                            accurate.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Intellectual Property
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            All content on the Site is protected by copyright. We, or Our licensors, own
                            copyright and/or database rights in the selection, coordination, arrangement and
                            enhancement of such content, as well as in the original content.
                            Except as expressly set out in these Terms & Conditions, nothing shall give you
                            any rights in respect of any intellectual property owned by Us or Our licensors.
                            You shall not assert or attempt to obtain any such rights and you shall not use,
                            copy, reproduce, modify, publish, transmit, participate in the transfer or sale
                            of, create derivative works from, or in any way exploit, Our name, trade marks,
                            logos or other proprietary marks, or any of the content of the Site, in whole or
                            in part, except as provided in these Terms & Conditions.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            You may download information from the Site for your own personal non-commercial
                            use only. Except as otherwise expressly permitted under copyright law, no
                            copying, redistribution, retransmission, publication or commercial exploitation
                            of downloaded material will be permitted without Our express permission and that
                            of the copyright owner. In the event of any permitted copying, redistribution or
                            publication of copyright material, no changes in or deletion of author
                            attribution, trade mark legend or copyright notice shall be made. You
                            acknowledge that you do not acquire any ownership rights by downloading
                            copyright material.
                            The rights granted to you under these Terms & Conditions shall terminate
                            immediately upon your breach of any of these Terms of Use.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Communications
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Whilst We are always happy to hear from you, it is Our policy not to accept or
                            consider creative materials, ideas or suggestions other than those We
                            specifically request. This is to avoid any misunderstandings if your ideas are
                            similar to those We have developed independently. Therefore, We request that you
                            do not send to Us any original creative materials such as original artwork etc.
                            Any communication or material you do transmit to the Site by electronic mail or
                            otherwise will be treated as non-confidential and non-proprietary.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Anything you transmit or post may be used by Us or our affiliates for any
                            purpose, including but not limited to, reproduction, disclosure, transmission,
                            publication, broadcast and posting. We are free to use any ideas, concepts,
                            know-how or techniques contained in any communication you send to the Site for
                            any purpose whatsoever including, but not limited to, developing, manufacturing
                            and marketing products using such information.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Linked Sites
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Please note that We reserve the right to suspend or terminate your account if it
                            is or appears to Us to be used in breach of any of the provisions of these Terms
                            and Conditions, including the provision of false registration details or any
                            other misuse of the Site. Any person who holds such a suspended or terminated
                            account must not re-register on the Site without Our prior consent.
                        </div>
                        <br/>
                    </div> : <></>}
                </div>

                <div className='about-us-tab-container'>
                    <div className='about-us-tab' onClick={this.tradingTerms.bind(this)}>
                        <div className='about-us-tab-child'>
                            {
                                this.state.tradingTerms ? <img className='arrow-rotate' alt='error-img' src={arrow}/> :
                                    <img className='arrow' alt='error-img' src={arrow}/>
                            }
                            Trading Terms
                        </div>
                    </div>
                    {this.state.tradingTerms ? <div className='about-us-tab-content'>
                        <div className='about-us-tab-div section-content-highlight'>
                            What these terms cover.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            These are the terms and conditions on which we supply products to you, whether
                            these are goods, services or digital content.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Why you should read them.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Please read these terms carefully before you submit your order to us. These
                            terms tell you how we will provide the product to you, how you and we
                            may change or end the contract, what to do if there is a problem and other
                            important information. If you think that there is a mistake in these terms,
                            please contact us to discuss.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            How we may contact you.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If we have to contact you we will do so by telephone or by writing to you at the
                            email address or postal address you provided to us in your order.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            You agree to inform us
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            if your name, email address or any other contact or personal details provided
                            change by contacting our customer service team on the number or email address
                            set out above and you agree that we will not be responsible for missed
                            notifications if you have not kept your contact details with us
                            up-to-date.”Writing” or “written” includes emails.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Pricing Policy
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We continue to review Our service to ensure that customers keep coming back to
                            Us for more than just great value in our product We sell.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            The prices of the product advertised for sale on the Site are as set out on the
                            Site, errors and omissions excepted. All prices are in US dollar,
                            inclusive of VAT (where applicable) at the current rates.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Prices may change at any time prior to acceptance of your order.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            In the unlikely event that the price of an item has been incorrectly advertised
                            on the Site, We will usually contact you to ask whether you wish to proceed with
                            your order at the correct price. If you are not happy to proceed, or We are
                            unable to obtain your instructions, We will cancel your order and any sum
                            debited by Us from your debit/credit card will be refunded in full to the same
                            card. We will not be obliged to supply products at the incorrect price.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Warning:
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We reserve the right not to supply any age-restricted product where We
                            reasonably believe that a customer is below the relevant minimum age.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Product Information
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We are under a legal duty to supply the product which conform with the contract We
                            have entered into with you. Further information about Our products and services
                            is set out in Our Products and Services help pages.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We have taken reasonable steps to display as accurately as possible the product descriptions
                            on the Site.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Unless otherwise stated, offers cannot be used in conjunction with any other
                            offer (online or otherwise). All offers are subject to availability while stocks
                            last. Offers may be withdrawn without notice for reasonable cause.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            The feature on the Site of a product does not constitute a guarantee of its
                            availability. Products, prices and technical requirements are subject to change
                            at any time without notice.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Product Limits
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We reserve the right in our absolute discretion. If we detect a breach or attempted breach
                            of these terms, we may cancel the relevant order.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Our Contract with you
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Further information about placing and paying for an order is set out in Our
                            Ordering and Payment help pages.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            You may place an order to purchase the product advertised for sale on the Site. You will
                            have an opportunity to check and correct any input errors in your order up until the point
                            at which you submit your order (by clicking ‘pay now’ on the‘payment’ page of the checkout
                            procedure).
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            the order placed by you are subject to acceptance by us. We may choose not to accept your
                            order for any reason and will not be liable to you or to anyone else in those circumstances.
                            On any such occasion We will email you to make you aware as soon as it is possible to do
                            so.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            You will receive an email, once your order is in process detailing your order reference and
                            details of the product(s) you have ordered. Please note that this email is an
                            acknowledgement only and is not an acceptance of your order.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Acceptance of your order and the formation of a contract between you and Us will
                            take place when We send you an email confirming that the products you have
                            ordered are being dispatched to you, unless We have notified you that We do not
                            accept your order or you have already cancelled it in accordance with the
                            provisions below (see Cancelling an Order).
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If we are unable to accept your order, we will inform you of this and will not
                            charge you for the product. This might be because we have identified an error in
                            the price or description of the product.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If you order may not be available. If this happens We
                            will cancel your order, send you an email to confirm the cancellation and any sum debited by
                            Us from your debit/credit card will be refunded in full to the same card.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Preowned Items
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            You can purchase pre-owned software with confidence through the
                            Site. Most pre-owned software comes boxed with instructions and is
                            fully tested. We cannot guarantee the condition of pre-owned product; they may
                            appear slightly blemished. However, all pre-owned stock is checked, and where
                            necessary reconditioned, prior to being put on sale on the Site.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Pre-released orders
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Pre-released orders (preorders) are orders for items that have not yet become
                            available. You may be able to make a pre-released order using the Site, and
                            where possible (and subject to availability) such orders will be shipped to you
                            on the day prior to release, in order that you may receive it on the release
                            date. Release dates are set by the manufacturers and are subject to change. As a
                            result We are not liable for any changes to a pre-release date advertised by Us.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Pre-release orders will be supplied at the price applicable at the time of
                            order, or the price applicable when your order is processed prior to dispatch,
                            whichever is lower.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Payment
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We cannot accept your order until you have paid for it in full. You can pay by
                            all major credit or debit cards listed on the Site. Please note We are unable to
                            accept payment by American Express. Payment will be charged at the point of
                            submitting your order, usually just before dispatch.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            For pre-release orders your card will be preliminarily checked for security
                            purposes. You will be charged for the full amount of your order.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Upon submitting your order, you confirm that the payment card that is being used
                            is yours.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            All credit/debit card holders are subject to validation and fraud checks and
                            authorisation by the card issuer. If the issuer of your payment card refuses to
                            authorise payment to us, We will not accept your order, We will not be obliged
                            to inform you of the reason for the refusal and We will not be liable for any
                            delay or non-delivery. We are not responsible for your card issuer charging you
                            as a result of Our processing of your credit/debit card payment in accordance
                            with your order.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            You authorise Us to debit your nominated payment card to recover all charges and
                            amounts due to Us.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Click & Reserve
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Sometimes the price of an order will change between the point of reservation and collection
                            in store.
                            The price you pay will be the lower of:
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (1) the price at the point of reservation or
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            (2) the price at the point of purchase and collection. We will not honour any price
                            fluctuations between these two points.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Our Pricing Policy (as set out above) also applies to Click & Reserve orders.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We will only honour reservations where you present a valid order reference number as
                            provided in our email confirmation.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We may also require you to provide the e-mail address and telephone number associated with
                            the account through which the order was placed.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Collect From Store (Click & Collect)
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We will only honour Collect From Store (Click & Collect) orders where you present all of the
                            following at the point of collection:
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            the confirmation email from when the order was placed
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            the credit or debit card that was used to place the order;
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            verification of your identity in the form of:
                            (i) a passport OR Drivers Licence; AND
                            (ii) a utility bill/statement dated within the last 3 months (including corresponding
                            address).
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Where a request by us for proof of ID is not met, we reserve the right to refuse your
                            collection attempt.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If, in our opinion, any person or persons, whether acting on behalf of themselves or a
                            business, engages in practices that call into question the fair use of the Collect From
                            Store (Click & Collect) system, we reserve the right to cancel orders (and where
                            appropriate, refund the value of the product to the original purchase method).
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            The right to use of the product shall not pass to you until you have payed.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Refunds for product purchased online using the service may be requested. See our
                            Cancellations and Returns Policy below for further information.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Cancellations and Returns Policy
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Please refer to our Returns Policy HERE for information on (i) your rights to return a
                            product under our 28 day goodwill return policy, (ii) your rights to return the product
                            because we are at fault, or because the product is faulty, and (iii) your 14 day right to
                            cancel under the Consumer Contracts Regulations 2012
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Our liability
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We are responsible to you for software fault. If we fail to comply
                            with these Terms, we are responsible for loss or damage you suffer that is a foreseeable
                            result of our breaking this contract or our failing to use reasonable care and skill.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We do not exclude or limit in any way our liability to you where it would be unlawful to do
                            so. This includes liability for fraud or fraudulent misrepresentation; for breach of your
                            legal rights including the right to receive product which are: as described and match
                            information we provided to you; of satisfactory quality; fit for any particular purpose made
                            known to us; supplied with reasonable skill and care; and for defective products under the
                            Consumer Protection Act 1987.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We shall not be liable for any delay or failure to perform any of Our obligations insofar as
                            the performance of such obligations is prevented by an event or by matters beyond Our
                            reasonable control.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Nothing in this section or elsewhere in these Terms & Conditions affects your statutory
                            legal rights.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Distributors Rights
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            You agree to be bound by any terms and conditions imposed by the distributor or producer of
                            any product or service or any other copyright material and in particular you must not:
                            (a) make copies of material supplied to you by Us for sale or rental or for any other reason
                            whatsoever; or
                            (b) show any copyright material in a public place or for profit.
                        </div>
                        <br/>
                        <div className='about-us-tab-div section-content-highlight'>
                            Other Important terms
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We may transfer any contract made under these Terms to someone else. We may transfer our
                            rights and obligations under these Terms to another organisation.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            You may only assign or transfer your rights under these Terms & Conditions if we agree to
                            this in writing.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If a court finds part of these Terms illegal, the rest will continue in force. Each of the
                            paragraphs of these Terms operates separately. If any court or relevant authority decides
                            that any of them are unlawful, the remaining paragraphs will remain in full force and
                            effect.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Even if we delay in enforcing this contract, we can still enforce it later. If we do not
                            insist immediately that you do anything you are required to do under these terms, or if we
                            delay in taking steps against you in respect of your breaking this contract, that will not
                            mean that you do not have to do those things and it will not prevent us taking steps against
                            you at a later date. For example, if you miss a payment and we do not chase you but we
                            continue to provide the products, we can still require you to make the payment at a later
                            date.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Which laws apply to this contract and where you may bring legal proceedings. These terms are
                            governed by American law and you can bring legal proceedings in respect of the product in
                            the American courts. If you live in Scotland you can bring legal proceedings in respect of
                            the products in either the Scottish or the American courts. If you live in Northern Ireland
                            you can bring legal proceedings in respect of the products in either the Northern Irish or
                            the American courts.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Online Dispute Resolution. In addition, please note that disputes may be submitted for
                            online resolution to the American Commission Online Dispute Resolution platform.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Any formal legal notices should be sent to Us at the address which we provide online.
                        </div>
                        <br/>
                    </div> : <></>}
                </div>

                <div className='about-us-tab-container'>
                    <div className='about-us-tab' onClick={this.prePayment.bind(this)}>
                        <div className='about-us-tab-child'>
                            {
                                this.state.prePayment ? <img className='arrow-rotate' alt='error-img' src={arrow}/> :
                                    <img className='arrow' alt='error-img' src={arrow}/>
                            }
                            Pre-payment Terms and Conditions
                        </div>
                    </div>
                    {this.state.prePayment ? <div className='about-us-tab-content'>
                        <div className='about-us-tab-div section-content-highlight'>
                            Pre-Payment Paid by Customers Ahead of New Software Releases Terms and Conditions
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Please read these Pre-Payment Terms carefully before making your Pre-Payment as the terms
                            and conditions set out below will apply.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We reserve the right to change these Pre-Payment Terms and when we do. Our new Pre-Payment
                            Terms will be available online.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            These Pre-Payment Terms apply alongside and in addition to Our Terms and Conditions of Sale
                            which apply to all sales made by Us online.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Nothing in these Pre-Payment Terms or in Our Terms and Conditions of Sale are intended to or
                            will have the effect of excluding or reducing your statutory rights as a consumer.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            When you order a software product in advance of its release date you may be given the option
                            to pay for the software product in full at the time of order. The price you pay for the
                            product will be determined by online staff when you make the Pre-Payment.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Payment will be taken using cash, credit or debit card, a Gift Card, or other Game Gift
                            Cards that you may have. At that point you will have bought your new software product. You
                            will be issued with a collection pack which you must retain as you will require it to
                            collect your software product at the time of release.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Please take good care of your collection pack as you must present it when collecting your
                            software product and we reserve the right not to release the product without it. If you do
                            not bring it with you at time of collection there may be considerable delay whilst we check
                            your entitlement to the product and you may not be able to collect it on the release date.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Pre-Payment can be made a number of weeks prior to the software product’s expected release
                            date (as determined by online staff).
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Sometimes the price of a software product will decrease between the time a Pre-Payment is
                            made and the software product’s release date. If this happens, the difference in price will
                            be refunded to you when you use the software product online.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If, having paid a pre-payment, you change your mind and cancel your order, except where this
                            is as a result of Our breach, We reserve the right to retain a sum to cover Our expenses in
                            dealing with the administration of your order and its cancellation as well as Our lost
                            business resulting from your cancellation.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            By making a pre-payment and providing Us with your contact details you agree to Us
                            contacting you with regard to the software product.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            These Pre-Payment Terms shall be interpreted under American Law and shall be subject to the
                            exclusive jurisdiction of the American.
                        </div>
                        <br/>
                    </div> : <></>}
                </div>

                <div className='about-us-tab-container'>
                    <div className='about-us-tab' onClick={this.depositsPaid.bind(this)}>
                        <div className='about-us-tab-child'>
                            {
                                this.state.depositsPaid ? <img className='arrow-rotate' alt='error-img' src={arrow}/> :
                                    <img className='arrow' alt='error-img' src={arrow}/>
                            }
                            Deposits paid by customers ahead of new product releases
                        </div>
                    </div>
                    {this.state.depositsPaid ? <div className='about-us-tab-content'>
                        <div className='about-us-tab-div section-content-highlight'>
                            Pre-Payment Paid by Customers Ahead of New Software Releases Terms and Conditions
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Please read these Pre-Order Terms carefully before placing your pre-order as the terms and
                            conditions set out below will apply.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We reserve the right to change Our Pre-Order Terms and when we do so Our new Pre-Order Terms
                            will be available in Our stores. The Pre-Order Terms applicable at the time you pay a
                            pre-order will however apply to that Pre-Order irrespective of any later changes in Our
                            Pre-Order Terms.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            These Pre-Order Terms apply alongside and in addition to Our Terms and Conditions of Sale
                            which apply to all sales made by Us online.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Nothing in these Pre-Order Terms or in Our Terms and Conditions of Sale are intended to or
                            will have the effect of excluding or reducing your statutory rights as a consumer.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            When you order the product in advance of its release date we will ask you for a deposit by
                            way of a reservation fee. The level of deposit payment required will vary depending on the
                            product being ordered. We will tell you what you will need to pay as a deposit before you
                            place you place your pre-order.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Pre-ordered the product will be held by us for up to 48 hours from the product’s release
                            date only, after which they may be released and re-allocated to other customers.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If, having paid a deposit for your pre-order, you either (i) change your mind and cancel
                            your order before the release date of the product, or (ii) return the product after the
                            release date under our 30 Day Return Policy, or (iii) fail to use the product that you
                            have ordered within 48 hours of its release date (which shall be deemed to be a
                            cancellation), except where this is as a result of Our breach, we reserve the right to
                            retain a sum to cover Our expenses in dealing with the administration of your order and its
                            cancellation as well as Our lost business resulting from your cancellation.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Sometimes supplies of new product are not available to us on the expected dates and placing
                            a pre-order with payment of a deposit does not guarantee availability of any product on a
                            specific date.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If however We are for any reason unable to supply you with the product within a
                            reasonable time of the expected availability date, We will always try to offer you the
                            product. If however We cannot offer you an alternative which you find
                            acceptable and as a result you cancel your order, We will refund your pre-order deposit for
                            the item concerned in full.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            By paying a deposit and providing Us with your contact details when placing a pre-order you
                            agree to Us contacting you with regard to the product (for example, to advise you of special
                            packages or special editions or pre-payment plan options or other aspects that may be of
                            interest to you).
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            These Pre-Order Terms apply to pre-orders made online only and do not apply to
                            on-line transactions.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            These Pre-Order Terms shall be interpreted under American Law and shall be subject to the
                            exclusive jurisdiction of the American Courts.
                        </div>
                        <br/>
                    </div> : <></>}
                </div>

                <div className='about-us-tab-container'>
                    <div className='about-us-tab' onClick={this.membershipReward.bind(this)}>
                        <div className='about-us-tab-child'>
                            {
                                this.state.membershipReward ?
                                    <img className='arrow-rotate' alt='error-img' src={arrow}/> :
                                    <img className='arrow' alt='error-img' src={arrow}/>
                            }
                            Membership Reward
                        </div>
                    </div>
                    {this.state.membershipReward ? <div className='about-us-tab-content'>
                        <div className='about-us-tab-div'>
                            These Terms and Conditions (and the Membership Privacy Policy) form a contract between
                            nebulabinary Inc. and you, the ‘Account Holder’, in relation to how Membership Reward points
                            are earned and spent.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            The Membership Reward programme is open to any person who use the software product and is
                            accepted for a
                            Membership Reward account at www.nebulabinary.com may extend, amend or terminate the
                            Membership Reward programme at its discretion, or amend these Terms and Conditions at any
                            time in which case the product will post notices on its website at www.nebulabinary.com. If
                            you apply for a Membership Reward account. you must confirm that you accept these Terms and
                            Conditions. The product may refuse an application for a Membership Reward account if it has
                            good reason to do so.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If you apply for a Membership Reward account online you will need to provide one of
                            the sales team with your title, forename, surname, address and gender. You will need to
                            create a Membership account and you will be required to
                            input the same information together with a valid email address and your date of birth.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            An administration fee is chargeable on an application for a Membership Reward account. This
                            fee may be waived at product’s discretion.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Account Holders will receive points on qualifying purchases. we reserves the right to remove
                            incorrectly calculated Reward points and/or Reward points which have been added erroneously.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We reserves the right to vary the rate at which Membership Reward points are earned
                            (including
                            offering bonus points from time to time) on providing 14 days’ notice. Notice is properly
                            given if we post details of any changes at www.nebulabinary.com and in store.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Account Holders can redeem Membership Reward points against purchases online. The minimum
                            redemption is 400 points against a purchase but any number of points above 400 can be
                            redeemed pro-rata. No change or credit will be given for any overpayment using points. GAME
                            reserves the right to vary the number of points required to be redeemed against a purchase.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Points cannot be redeemed until registered on an Account Holder’s Membership Reward account.
                            Note that as stated above, it takes around 24 hours for points earned to register.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Membership Reward points can be used as part payment towards the product online. Membership
                            Reward points will be not earned on products where points have been redeemed as payment or
                            part payment for that product.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Membership Reward points have no cash redemption value. Membership Reward points are for
                            Account Holder’s personal use and cannot be exchanged, sold or transferred to another
                            Account Holder’s account.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If a transaction on which points are earned or redeemed is cancelled or reversed or a
                            product is returned (in accordance with Returns Policy), we will reverse the associated
                            points earned or redeemed.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We are committed to protecting Account Holders’ privacy and will only use the
                            information that we collect about Account Holders in accordance with all applicable data
                            protection and privacy legislation, regulations and guidance. In our privacy policy we
                            explain how we look after Account Holders’ personal data, as well as personal data we
                            receive when individuals visit our websites, buy products or services from us online. We
                            also explain the data privacy rights of individuals and how the law protects them. It is
                            important that our privacy policy is read together with any other privacy policy or fair
                            processing notice we may provide on specific occasions when we are collecting or processing
                            personal data. Our privacy policy is in addition to the other notices and is not intended to
                            override them.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            It is the responsibility of the Account Holder to notify the product of any change to or
                            error in their contact details. Details can be updated online. We reserves the right to
                            suspend a Membership Reward account if an Account Holder’s contact details are incomplete or
                            inaccurate.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            We reserves the right to amend these Terms and Conditions, or suspend or terminate the
                            Membership Reward programme at any time. We will notify Account Holders of any changes to
                            these Terms and Conditions by posting notices at www.nebulabinary.com. We will where
                            reasonably possible give Account Holders 14 days’ notice of any changes, suspension or
                            termination. Earning or redeeming points after notice is posted will constitute acceptance
                            of any amended Terms and Conditions.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Account Holders can terminate their Membership Reward account on written notice to us at any
                            time.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Any Account Holder may only hold one Membership Reward account at any time. We reserves
                            the right to de-duplicate its lists of Account Holders by terminating or merging Membership
                            Reward accounts that it reasonably believes to be duplicates issued to the same Account
                            Holder.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If we reasonably believes that an Account Holder is in breach of these Terms and Conditions
                            or that the Account Holder has abused the Membership Reward programme, we reserves the right
                            to take any appropriate action, including suspending or terminating the Account Holder’s
                            Membership Reward account.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If the Membership Reward programme or an individual account is terminated (for whatever
                            reason) the Account Holder’s right to earn or redeem points is lost.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            If an Account Holder has not used their Membership Reward account for a period of 12 months
                            or more, their Membership Reward account balance may be reset to zero. Where this occurs
                            We may continue to hold your details unless you ask us to delete them. Account Holders are
                            entitled to apply to have their Membership Reward account reactivated and We may, at its
                            discretion, re-award any points which were held in the Account Holder’s account at the time
                            the account was zeroed. Re-instatement will not however be possible if you have asked us to
                            delete your details.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            No party other than the Account Holder and we have any rights under the Contracts (Rights
                            of Third Parties) Act 1999 or any equivalent legislation in any jurisdiction, or otherwise,
                            to enforce any term of these Terms and Conditions.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            These Terms and Conditions are subject to and shall be interpreted under US Law.
                        </div>
                        <br/>
                        <div className='about-us-tab-div'>
                            Any dispute arising under or in connection with these Terms and Conditions is subject to the
                            exclusive jurisdiction of the US courts.
                        </div>
                        <br/>
                    </div> : <></>}
                </div>
            </div>
            <Footer/>
        </div>);
    }
}

export default aboutUs